import effectManager from '../module/effect';
import MainvisualManager from './mainvisual';
import SectionManager from './section';
import actionSlideManager from './actionSlide';
import aboutModalManager from './aboutModal';
// import ProductsManager from './products';
import NewsManager from './news';

let effect = new effectManager();
let news = new NewsManager();
news.init();

export default class topManager {
    constructor() {

        // this.effect = new effectManager();
        // this.effect.splitText($(".js__sc-split"),"set")

        this.$target =  $(".p-section");
        this.$fixedMovieBtn = $("#p-btn-movie");
        this.$headerMovieBtn = $("#l-header-play"); /* SP用 */
        this.$scrollDown = $("#l-scrolldown"); /* SP用 */
        this.MAX =  this.$target.length - 1;

        this.mainvisual = new MainvisualManager();
        this.section = new SectionManager();
        this.actionSlide = new actionSlideManager();
        this.aboutModal = new aboutModalManager();
        // this.products = new ProductsManager();


        this.status = {
            firstFlg:false, /* 初回表示が完了しているか */
            firstStFlg:false, /* 初回表示がスタートしたか */
            movieFlg:false, /* 動画を再生しているか */
            modalFlg:false, /* モーダルを表示中か判定 */
            fixedMvBtnFlg : false, /* 固定用のムービーボタンが表示されているか */
            current : 0,
            prevCurrent:0,
            dir : "",
            timer : "",
            update : {
                flg : false,
                timestamp:0,
            },
            section : []
        }


    }
    init(){

        this.mainvisual.init();
        effect.svg($(".js__svg"),"set");
        effect.show($(".js__show__inner,.js__show-01__inner"),"set");
        effect.line($(".js__line"),"set");
        effect.splitText($(".js__splittext"),"set");
        effect.cover(!Useragnt.mobile?$(".js__cover"):$(".js__cover-sp"),"set");


        this.actionSlide.init();
        this.aboutModal.init();
        // this.products.init();


        let _this = this;

        this.aboutModal.$trigger.on("click touchstart",function () {
            _this.aboutModal.status.select =  $(this).attr("data-target");

            _this.aboutModal.open($("#p-"+_this.aboutModal.status.select+",#p-lowlayer-header"),_this.aboutModal.status.select);

            _this.status.modalFlg = true;

        });

        this.aboutModal.$close.on("click touchstart",function () {
            TweenMax.set($("#p-"+_this.aboutModal.status.select),{scrollTo:0})
            _this.aboutModal.close($("#p-"+_this.aboutModal.status.select+",#p-lowlayer-header"),_this.aboutModal.status.select);

            _this.status.modalFlg = false;

        });

        /* 各センテンスステータス保存用の変数用意 */
        for(let i=0; i<=this.MAX; i++){
            this.status.section[i]={
                timer :""
            }
        }

        // setTimeout(()=>this.status.firstFlg=true,2e3);

    }
    update(e,current,dir,type){

        this.status.dir = dir!==""?dir:this.status.dir;

        if(this.status.prevCurrent!=this.status.current) this.status.prevCurrent = this.status.current;

        if(current||type==="pagetop"){
            this.status.prevCurrent = this.status.current;
            this.status.current =  current;
        }else{

            if(this.status.dir=="next"){
                if(this.status.current<this.MAX){
                    this.status.prevCurrent = this.status.current;
                    this.status.current += 1;
                }else{
                    this.status.prevCurrent = this.MAX;
                    this.status.current = 0;
                }
            }else{
                if(this.status.current>0){
                    this.status.prevCurrent = this.status.current;
                    this.status.current -= 1;
                }else{
                    this.status.prevCurrent = 0;
                    this.status.current = this.MAX;
                }

            }

        }

        clearTimeout(this.status.timer);
        this.status.timer = setTimeout(()=>{
            this.$target.eq(this.status.current).addClass("is-current");
            this.$target.eq(this.status.prevCurrent).removeClass("is-current");
        },1e3);

        clearTimeout(this.status.section[this.status.prevCurrent].timer)

        switch (this.status.current){
            case 0:
                if(!this.mainvisual.status.flg) this.mainvisual.status.timer=setTimeout(()=>this.mainvisual.show(),1e3);
                if(this.section.status[this.status.prevCurrent].flg){
                    this.section.out(this.status.prevCurrent)
                }
                if(this.status.fixedMvBtnFlg){
                    this.status.fixedMvBtnFlg=false;
                    if(Useragnt.mobile){
                        this.$headerMovieBtn.removeClass("is-active");
                        effect.show(this.$headerMovieBtn,"out");
                        // this.$scrollDown
                        effect.show(this.$scrollDown,"show");

                    }else{
                        this.$fixedMovieBtn.removeClass("is-active");
                        effect.show(this.$fixedMovieBtn.find(".js__show__inner"),"out")
                    }
                }
                break;
            default:

                if(this.mainvisual.status.flg||this.status.prevCurrent==0) {
                    clearTimeout(this.mainvisual.status.timer);
                    this.mainvisual.out()
                }else if(this.section.status[this.status.prevCurrent].flg){
                    this.section.out(this.status.prevCurrent)
                }

                if(!this.section.status[this.status.current].flg){
                    this.status.section[this.status.current].timer = setTimeout(()=>this.section.show(this.status.current),5e2);
                }

                if(!this.status.fixedMvBtnFlg) {
                    this.status.fixedMvBtnFlg = true;
                    if(Useragnt.mobile){
                        this.$headerMovieBtn.addClass("is-active");
                        effect.show(this.$headerMovieBtn,"show");
                        effect.show(this.$scrollDown,"out");
                    }else{
                        this.$fixedMovieBtn.addClass("is-active");
                        effect.show(this.$fixedMovieBtn.find(".js__show__inner"),"show")
                    }
                }

                break;
        }




        // if(this.status.current==4){
        //     if(this.status.prevCurrent==0&&this.section.status[this.status.current].flg){
        //         if(Useragnt.mobile){
        //             this.$headerMovieBtn.addClass("is-active");
        //             effect.show(this.$headerMovieBtn,"show");
        //             effect.show(this.$scrollDown,"out");
        //         }else{
        //             this.$fixedMovieBtn.addClass("is-active");
        //             effect.show(this.$fixedMovieBtn.find(".js__show__inner"),"show");
        //         }
        //     }
        // }

        // console.log(this.status.prevCurrent,this.status.current);


    }
    render(mouse){

        if(this.status.current==2) this.actionSlide.render();

    }
    resize(){

    }
}